import client from './client';

/**
 * Phase 1 - extends sessions API with notes / scorecard / readiness.
 * The core CRUD lives in ./sessions.js; this module groups the new endpoints.
 */

export const updateSessionNotes = (sessionId, notes) =>
  client.patch(`/api/sessions/${sessionId}/notes`, { notes });

export const updateSessionScorecard = (sessionId, scorecard) =>
  client.patch(`/api/sessions/${sessionId}/scorecard`, { scorecard });

export const updateSessionReadiness = (sessionId, readiness) =>
  client.post(`/api/sessions/${sessionId}/readiness`, { readiness });
